var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagLiberia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.65726 5.81824H28.3428C27.431 4.71418 26.3735 3.73512 25.2004 2.90918H6.79957C5.62651 3.73499 4.56907 4.71412 3.65726 5.81824Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 15.9999C0 16.4903 0.0233125 16.9752 0.0665 17.4545H31.9335C31.9767 16.9752 32 16.4903 32 15.9999C32 15.5095 31.9767 15.0246 31.9335 14.5454H0.0665C0.0233125 15.0246 0 15.5095 0 15.9999H0Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.74476 23.2728H30.2553C30.7264 22.3511 31.1106 21.378 31.3975 20.3638H0.602509C0.889321 21.378 1.2737 22.3512 1.74476 23.2728Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.79957 29.0909H25.2004C26.3734 28.265 27.4309 27.2859 28.3427 26.1819H3.65726C4.56907 27.2858 5.62651 28.265 6.79957 29.0909Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.602448 11.6364H31.3976C31.1107 10.6221 30.7264 9.64886 30.2553 8.72729H1.74476C1.2737 9.64886 0.889323 10.6221 0.602448 11.6364Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65244 2.90906H25.2007C22.5982 1.07669 19.4251 0 16.0002 0C13.9133 0 10.2549 1.07669 7.65244 2.90906Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3048 8.72742H30.2557C29.7236 7.68661 29.081 6.71167 28.3432 5.81836H15.3048V8.72742Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3048 14.5455H31.9339C31.8439 13.5467 31.663 12.5739 31.398 11.6365H15.3048V14.5455Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.602498 20.3637H31.3975C31.6626 19.4263 31.8435 18.4535 31.9335 17.4546H0.0664978C0.156498 18.4535 0.337373 19.4262 0.602498 20.3637Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.65771 26.1818H28.3432C29.081 25.2883 29.7236 24.3135 30.2557 23.2727H1.74521C2.27727 24.3135 2.9199 25.2885 3.65771 26.1818Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 31.9999C19.4251 31.9999 22.5983 30.9232 25.2008 29.0908H6.7999C9.4024 30.9232 12.5755 31.9999 16.0003 31.9999Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.602435 11.6364C0.33731 12.5739 0.156498 13.5466 0.0664978 14.5454H16V0C8.67625 0 2.50194 4.92075 0.602435 11.6364Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.52425 4.17383L10.5602 7.36227H13.9131L11.2007 9.33302L12.2366 12.5216L9.52425 10.551L6.81181 12.5216L7.84793 9.33302L5.13556 7.36227H8.48825L9.52425 4.17383Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15871"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagLiberia);
export default __webpack_public_path__ + "static/media/flag_liberia.6c3bdf9a281c1329a4d1ef9fc032c15b.svg";
export { ForwardRef as ReactComponent };